import { render, staticRenderFns } from "./InventoryEditModal.vue?vue&type=template&id=a635611a"
import script from "./InventoryEditModal.vue?vue&type=script&lang=js"
export * from "./InventoryEditModal.vue?vue&type=script&lang=js"
import style0 from "./InventoryEditModal.vue?vue&type=style&index=0&id=a635611a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports